export const getContactedAd = ({isAlreadyContacted}) => Boolean(isAlreadyContacted)
